import { Suspense } from "react";

import { PageSkeleton } from "@stacklet/ui";
import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { AccountGroupDetailsRoute } = lazily(
  () => import("./AccountGroupDetailsRoot"),
);

/**
 * The admin account group details route: see AccountGroupDetailsRoot.
 *
 * The read-only mirror of the same page (`/account-groups/:accountGroupUUID`)
 * stays on lazy load for now.
 */
export const accountGroupDetailsRoute: PreloadingRouteProps = {
  element: (
    <Suspense fallback={<PageSkeleton />}>
      <AccountGroupDetailsRoute />
    </Suspense>
  ),
  loader: lazyRouteLoader({
    load: () =>
      import("./accountGroupDetailsPreload").then((module) =>
        module.createAccountGroupDetailsLoader(),
      ),
    warm: () => import("./AccountGroupDetailsRoot"),
  }),
  // The details page keeps its own query up to date while it is mounted (see
  // useRoutePreloadedQuery), so the loader only runs again when the URL names
  // a different account group — not for the tab changes that also write to the
  // URL, which the page handles itself.
  shouldRevalidate: ({ currentParams, nextParams }) =>
    currentParams.accountGroupUUID !== nextParams.accountGroupUUID,
};
